let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("9zLwF"), load("ciEtA")]).then(() => parcelRequire('6faJr'));